import { Map } from 'immutable';
import { INITIAL, LOADING } from 'utils/store/fetch';
import { PATH } from '../const';

const STATE_KEY = PATH.split('/');

export const getState = (state) => state.getIn(STATE_KEY, Map());

export const getStatus = (state) => getState(state).get('status');

export const getHasLoaded = (state) =>
  getStatus(state) !== INITIAL && getStatus(state) !== LOADING;

export const getHasFetched = (state) => getStatus(state) !== INITIAL;

export const getError = (state) => getState(state).get('error');

export const getResults = (state) => getState(state).get('results');

export const getSurchargeFetchingStatus = (state) =>
  getState(state).get('status');

export const getSurcharge = (id, amount) => (state) =>
  getResults(state)?.get(`${amount}-${id}`);
